import { MEMBER_TIER_THRESHOLDS, TIER_LABELS, TIER_DESCRIPTIONS } from '@repo/shared/dtos/analytics/UtilizationConstants';

export const INACTIVE_THRESHOLD_DAYS = MEMBER_TIER_THRESHOLDS.INACTIVE_THRESHOLD_DAYS;

export const REGULAR_MEMBER_MIN = MEMBER_TIER_THRESHOLDS.REGULAR_MEMBER_MIN;
export const REGULAR_MEMBER_MAX = MEMBER_TIER_THRESHOLDS.REGULAR_MEMBER_MAX;
export const POWER_MEMBER_MIN = MEMBER_TIER_THRESHOLDS.POWER_MEMBER_MIN;
export const CHAMPION_MIN = MEMBER_TIER_THRESHOLDS.CHAMPION_MIN;

export const TIER_LABEL_INACTIVE = TIER_LABELS.INACTIVE;
export const TIER_LABEL_REGULAR = TIER_LABELS.REGULAR;
export const TIER_LABEL_POWER = TIER_LABELS.POWER;
export const TIER_LABEL_CHAMPION = TIER_LABELS.CHAMPION;

export const TIER_DESC_INACTIVE = TIER_DESCRIPTIONS.INACTIVE;
export const TIER_DESC_REGULAR = TIER_DESCRIPTIONS.REGULAR;
export const TIER_DESC_POWER = TIER_DESCRIPTIONS.POWER;
export const TIER_DESC_CHAMPION = TIER_DESCRIPTIONS.CHAMPION;

export const TOP_USERS_PAGE_SIZE = 20;
export const TOP_USERS_CARD_LIMIT = 20;
export const TOP_USERS_MODAL_LIMIT = 500;
